import { SkeletonText, Stack, StackItem, Typography } from '@optimus-web/core';
import { CardContainer } from '@mews/b2b-ui';
import { LocalizedText } from '@mews/framework';
import { LocalizedDateFromUtc } from '@mews-commander/ui';

interface HighlightCardProps {
    title: Mews.TextKey;
    date: string;
    content?: React.ReactNode;
    loading?: boolean;
    error?:
        | null
        | boolean
        | {
              message: React.ReactNode;
          };
}

export const HighlightCard = ({ title, date, content, loading, error }: HighlightCardProps) => (
    <CardContainer data-test-id="balance-card">
        <Stack vertical spacing="100">
            <StackItem>
                <Typography data-test-id="title" textStyle="bodyLargeStrong" as="div">
                    <LocalizedText textKey={title} />
                </Typography>
                <Typography data-test-id="date" textStyle="bodySmall" variant="tertiary" as="div">
                    <LocalizedDateFromUtc utcString={date} />
                </Typography>
            </StackItem>
            {loading && <SkeletonText data-test-id="balance-skeleton-text" width="66%" />}
            {error && (
                <Stack itemAlignment="center" alignment="center" distribution="stretch" fill>
                    <Typography textStyle="bodySmall" align="center" as="div">
                        {typeof error === 'object' && error.message}
                    </Typography>
                </Stack>
            )}
            {!loading && !error && (
                <Typography data-test-id="amount-currency" textStyle="highlightMedium" as="div">
                    {content}
                </Typography>
            )}
        </Stack>
    </CardContainer>
);
